import { useEffect, useState } from 'react';
import * as L from 'leaflet';

interface IProps {
  geomanLayerRef: any;

  field: any;
  onChange: any;
}

const useAddPolygonToLayerGroup = ({
  geomanLayerRef,
  field,
  onChange,
}: IProps) => {
  const [isFieldMounted, setIsFieldMounted] = useState(false);

  useEffect(() => {
    if (field && !isFieldMounted && geomanLayerRef.current) {
      setIsFieldMounted(true);
      const poly = L.polygon(field.coordinates);
      geomanLayerRef.current.addLayer(poly);
      poly.on('pm:edit', () => {
        onChange();
      });
    }
  }, [field, isFieldMounted, geomanLayerRef, onChange]);

  return isFieldMounted;
};

export default useAddPolygonToLayerGroup;
